import { Box, Group, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';
import { tokens } from '../theme';

export function Feature({ icon, title, description }: Readonly<{ icon: ReactNode; title: string; description: string }>) {
  return (
    <Group gap={14} align="flex-start" wrap="nowrap">
      <Box
        style={{
          width: 38, height: 38, borderRadius: 10, flexShrink: 0,
          background: tokens.greenSoft,
          border: `1px solid rgba(59, 212, 129, 0.28)`,
          color: tokens.green,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        {icon}
      </Box>
      <Stack gap={4} style={{ minWidth: 0 }}>
        <Text size="sm" fw={700} c={tokens.white}>{title}</Text>
        <Text size="xs" c={tokens.textMuted} style={{ lineHeight: 1.55 }}>{description}</Text>
      </Stack>
    </Group>
  );
}
